var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassignRider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 7.99967C9.84103 7.99967 11.3334 6.50729 11.3334 4.66634C11.3334 2.82539 9.84103 1.33301 8.00008 1.33301C6.15913 1.33301 4.66675 2.82539 4.66675 4.66634C4.66675 6.50729 6.15913 7.99967 8.00008 7.99967Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27319 14.6667C2.27319 12.0867 4.83988 10 7.99988 10C8.63988 10 9.25988 10.0867 9.83988 10.2467",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 11.9997C14.6666 12.213 14.6399 12.4197 14.5866 12.6197C14.5266 12.8863 14.4199 13.1463 14.2799 13.373C13.8199 14.1463 12.9733 14.6663 11.9999 14.6663C11.3133 14.6663 10.6933 14.4063 10.2266 13.9797C10.0266 13.8063 9.85326 13.5997 9.71993 13.373C9.47326 12.973 9.33325 12.4997 9.33325 11.9997C9.33325 11.2797 9.61992 10.6197 10.0866 10.1397C10.5733 9.63969 11.2533 9.33301 11.9999 9.33301C12.7866 9.33301 13.4999 9.67302 13.9799 10.2197C14.4066 10.693 14.6666 11.3197 14.6666 11.9997Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9932 11.9873H11.0066",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignRider);
export default __webpack_public_path__ + "static/media/unassign-rider.ee89008921ba9cedcb9fc40229ba3c81.svg";
export { ForwardRef as ReactComponent };